import { Grid2, useTheme } from '@mui/material'
import { memo } from 'react'

import { THEME_MODE } from '../../constants/theme'
import { Image } from '../shared/image'
import OutsideLink from '../shared/links/OutsideLink'

const ProvidersGrid = ({ spacing = 3, size = 6 }) => {
  const data = [
    {
      id: 'gateio',
      to: 'https://www.gate.io/trade/QBX_USDT'
    },
    {
      id: 'uniswap',
      to: 'https://app.uniswap.org/explore/tokens/ethereum/0x72fdc31f4a9a1edf6b6132d3c1754f1cdcf5d9b1'
    },
    {
      id: 'mexc',
      to: 'https://www.mexc.com/en-GB/exchange/QBX_USDT'
    },
    {
      id: 'bitmart',
      to: 'https://www.bitmart.com/trade/en-US?symbol=QBX_USDT'
    }
  ]
  const theme = useTheme()
  const mode = theme.palette.mode
  const isLight = mode !== THEME_MODE.DARK
  return (
    <Grid2 container rowSpacing={spacing} columnSpacing={spacing}>
      {data.map(({ id, to }) => (
        <Grid2
          key={id}
          sx={{
            bgcolor: isLight ? 'common.black' : 'common.white',
            borderRadius: 2,
            p: 2
          }}
          size={{ xs: 6, sm: size, md: size }}
          component={OutsideLink}
          label={
            <Image
              src={`/assets/exchange-logos/${id}-${isLight ? 'w' : 'b'}.png`}
            />
          }
          to={to}
        ></Grid2>
      ))}
    </Grid2>
  )
}

export default memo(ProvidersGrid)
